import React, { useEffect, useState } from 'react';
import { RowContainer, Typography, toast } from '../../../components/common';
import { SkeletonTable } from '../../../components/common/Skeletons';
import { useGetUser } from '../../../contexts/user';
import { GetUserSchedule } from '../../../services/Api/users/useApiUser';
import { getTimeFromMins } from '../../../services/Helpers/dateHelper';

const AgentDayRoutingProfileSummary = () => {
    const { userDetails } = useGetUser();
    const [isLoading, setIsLoading] = useState(true);
    const [scheduleData, setScheduleData] = useState([]);
    const todaysDayNumber = new Date().getDay();
    const todaysLongDate = new Date().toLocaleString('en-uk', {
        day: 'numeric',
        year: 'numeric',
        month: 'long',
    });
    const todaysDayName = new Date().toLocaleString('en-uk', { weekday: 'long' }).split(' ')[0];

    useEffect(() => {
        GetUserSchedule({ email: userDetails.username })
            .then((response) => {
                setScheduleData(
                    response.data
                        .filter((d) => d.day === todaysDayNumber)
                        .sort((a, b) => (a.time < b.time ? 0 : a.time > b.time ? 2 : 1))
                );
            })
            .catch((err) => {
                toast.error();
                console.error(err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [userDetails.username, todaysDayNumber]);

    if (isLoading) {
        return (
            <div>
                <SkeletonTable columns={5} rows={5} />
            </div>
        );
    }

    return (
        <div>
            {scheduleData && scheduleData.length ? (
                <div className="bg-brand-mainTransparent py-4 px-8 rounded-lg">
                    <RowContainer>
                        <Typography className="mr-4" variant="body1">
                            {todaysDayName}{' '}
                        </Typography>
                        <Typography variant="body1" color="brand-main">
                            {todaysLongDate}
                        </Typography>
                    </RowContainer>
                    {scheduleData.map((adrd) => {
                        return (
                            <div className="p-6 my-3 bg-white rounded-lg">
                                <RowContainer>
                                    <div className="w-1/4 block">
                                        <Typography className="pb-1" variant="heading1.1">
                                            {getTimeFromMins(adrd.time)}
                                        </Typography>
                                        <div
                                            className={`rounded-lg w-1/2 text-center ${
                                                adrd.autoaccept ? 'bg-brand-main' : 'bg-grey-normal'
                                            }`}
                                        >
                                            <Typography
                                                className="py-1"
                                                color="white"
                                                varient="heading2.2"
                                            >
                                                {adrd.autoaccept ? 'on' : 'off'}
                                            </Typography>
                                        </div>
                                    </div>
                                    <div className="w-3/4">
                                        <Typography
                                            className="pb-1"
                                            variant="body1"
                                        >{`${adrd.company} (${adrd.project})`}</Typography>
                                        <Typography className="pb-1" variant="body1.2">
                                            {adrd.routingprofilename}
                                        </Typography>
                                        <Typography className="pb-1" variant="body3">
                                            {adrd.acw} seconds
                                        </Typography>
                                    </div>
                                </RowContainer>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <div>You have no schedule today.</div>
            )}
        </div>
    );
};

export default AgentDayRoutingProfileSummary;
